import { getPlaceholderHtml as getSelectPlaceholderHtml } from '@components/field-mapping-select-field/extensions';
import { IconAddPlus } from '@components/icons/add-plus';
import { Menu } from '@components/menu';
import { SelectOption } from '@components/select';
import { useScopedTranslate } from '@locale/translate';

import { EditorRefProp } from '../common';
import { locale } from '../field-mapping-sidebar';

export const SelectManualField = ({
  editorRef,
  options,
}: EditorRefProp & { options: SelectOption[] }) => {
  const { t } = useScopedTranslate(locale);

  return (
    <Menu
      placement="bottom-start"
      buttonProps={{
        iconLeft: <IconAddPlus />,
        variant: 'secondary',
        text: t('manuallySelectValue'),
      }}
    >
      {options.map((option) => (
        <Menu.Item
          key={`${option.value}-${option.label}`}
          label={option.label}
          onSelect={() => {
            editorRef.current?.insertContent(
              getSelectPlaceholderHtml({ value: option.value, label: option.label as string }),
            );
          }}
        />
      ))}
    </Menu>
  );
};
